import * as React from 'react';
import {
    DataTable,
    TableBody,
    TableColumn,
    TableHeader,
    TableRow,
  } from "react-md/lib/DataTables";
import { ExpansionList, ExpansionPanel } from 'react-md/lib/ExpansionPanels';
import { BasicEstimate, ChildCalculationResult } from '../Calculation/types';

import "./EstimateWithBreakdown.scss";

interface Props {
    childEstimates: ChildCalculationResult[]
}

interface State {
}

export class EstimateWithBreakdown extends React.Component<Props, State> {
    public render() {

        const totalEstimate = this.props.childEstimates.reduce((working, currentResult) => {
            if (working === undefined || currentResult.estimate === undefined) {
                return undefined;
            }

            working.outOfPocketPerFornight += currentResult.estimate.outOfPocketPerFornight;
            working.subsidisedFortnightlyCost += currentResult.estimate.subsidisedFortnightlyCost;
            working.eligableForLowActivityBenefit = working.eligableForLowActivityBenefit || currentResult.estimate.eligableForLowActivityBenefit;
            return working;
        }, {
            subsidisedFortnightlyCost: 0,
            outOfPocketPerFornight: 0,
            eligableForLowActivityBenefit: false
        });

        return (
            <div className="estimate-with-breakdown">
                <ExpansionList>
                    <ExpansionPanel label="Total" footer={null} defaultExpanded={true}>
                        {this._renderEstimateTable(totalEstimate)}
                        {totalEstimate && totalEstimate.eligableForLowActivityBenefit ? <div className="estimate-notice">{this.props.childEstimates.length > 1 ? "One of your children" : "Your child"} may be entitled to 36 hours of care if they are starting school next year, please contact us for more information.</div> : null}
                    </ExpansionPanel>
                    <ExpansionPanel label="Breakdown" footer={null}>
                        {
                            this.props.childEstimates.map((result, index) =>
                                <div key={index} className="breakdown-child-estimate">
                                    <h4 >Child: {index + 1} ({result.enrolledChild.ageInMonths} months, {result.enrolledChild.attendSessionsPerWeek} days per week)</h4>
                                    {this._renderEstimateTable(result.estimate)}
                                </div>
                            )
                        }
                    </ExpansionPanel>
                </ExpansionList>
            </div>);
    }

    private _renderEstimateTable(estimate: BasicEstimate | undefined): JSX.Element {
        return <DataTable plain={true}>
            <TableHeader>
                <TableRow>
                    <TableColumn></TableColumn>
                    <TableColumn>Per Week</TableColumn>
                    <TableColumn>Per Fortnight</TableColumn>
                </TableRow>
            </TableHeader>
            <TableBody>
                <TableRow>
                    <TableColumn>Subsidy</TableColumn>
                    <TableColumn>{this._renderEstimateAmount(estimate, e => e.subsidisedFortnightlyCost / 2)}</TableColumn>
                    <TableColumn>{this._renderEstimateAmount(estimate, e => e.subsidisedFortnightlyCost)}</TableColumn>
                </TableRow>
                <TableRow>
                    <TableColumn>Out of pocket</TableColumn>
                    <TableColumn>{this._renderEstimateAmount(estimate, e => e.outOfPocketPerFornight / 2)}</TableColumn>
                    <TableColumn>{this._renderEstimateAmount(estimate, e => e.outOfPocketPerFornight)}</TableColumn>
                </TableRow>                                            
            </TableBody>
        </DataTable>        
    }

    private _renderEstimateAmount(estimate: BasicEstimate | undefined, accessor: (estimate: BasicEstimate) => number) : JSX.Element {
        if (estimate) {
            return <span>{this.formatCurrency(Math.ceil(accessor(estimate)))}</span>
        } else {
            return <span>Could not calculate</span>;
        }
    }

    private formatCurrency(amount: number): string {
        const formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 2 });
        
        return formatter.format(amount);    
      }
}
